import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { getLangFromWindow } from "@/utils/seoLang";

const content = {
  ru: {
    title: "Пользовательское соглашение",
    updated: "Дата последнего обновления: 28 марта 2025 г.",
    sections: [
      {
        title: "1. Общие положения",
        text: `Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует отношения между YUCCA Flowers (далее — «Сервис», «мы») и пользователем сайта yuccaflower.com (далее — «Пользователь», «вы»).

Используя сайт, вы подтверждаете, что прочитали, поняли и согласны с условиями данного Соглашения. Если вы не согласны с какими-либо условиями, пожалуйста, прекратите использование сайта.`
      },
      {
        title: "2. О сервисе",
        text: `YUCCA Flowers является агрегатором услуг по доставке цветов. Мы НЕ являемся флористическим магазином, НЕ имеем собственных точек продаж и НЕ осуществляем доставку букетов самостоятельно.

Все заказы выполняются третьими лицами — независимыми флористами и службами доставки в соответствующих городах. YUCCA Flowers выступает исключительно как платформа, связывающая клиентов с поставщиками услуг.

Мы прилагаем все усилия для подбора надёжных партнёров, однако не несём прямой ответственности за качество товаров и услуг, предоставляемых третьими лицами.`
      },
      {
        title: "3. Оформление заказа",
        text: `Заказы оформляются через мессенджеры WhatsApp и Telegram. При оформлении заказа вы указываете:
— Выбранный букет и его стоимость
— Адрес и время доставки
— Контактные данные получателя

После подтверждения заказа информация передаётся партнёру-исполнителю в выбранном городе.`
      },
      {
        title: "4. Цены и оплата",
        text: `Цены на сайте указаны в базовой валюте региона (USD для Турции, EUR для Испании). Конвертация в другие валюты осуществляется по текущему курсу с учётом комиссии за конвертацию.

Итоговая стоимость заказа может отличаться от указанной на сайте в зависимости от доступности конкретных цветов и условий доставки. Окончательная цена согласовывается при оформлении заказа.

Способы оплаты обсуждаются индивидуально при оформлении заказа через мессенджер.`
      },
      {
        title: "5. Доставка",
        text: `Доставка осуществляется третьими лицами — партнёрами сервиса в соответствующих городах. Сроки и условия доставки зависят от конкретного города, времени заказа и доступности курьеров.

Мы стремимся обеспечить доставку в день заказа, однако не можем гарантировать это во всех случаях. В случае задержки или проблем с доставкой мы содействуем в решении вопроса с партнёром.`
      },
      {
        title: "6. Фото перед отправкой",
        text: `Мы предоставляем услугу фотографирования букета перед отправкой. Фотография направляется заказчику через мессенджер для подтверждения. Внешний вид букета может незначительно отличаться от фото на сайте в зависимости от сезонной доступности цветов.`
      },
      {
        title: "7. Возврат и отмена",
        text: `Условия возврата и отмены заказа:
— Заказ может быть отменён до момента начала его исполнения (сборки букета) без каких-либо штрафов.
— После начала сборки букета возврат средств обсуждается индивидуально.
— В случае ненадлежащего качества букета мы содействуем в решении вопроса с партнёром-исполнителем.`
      },
      {
        title: "8. Ограничение ответственности",
        text: `YUCCA Flowers, являясь агрегатором, не несёт ответственности за:
— Качество и свежесть цветов, предоставленных третьими лицами
— Задержки в доставке, вызванные действиями партнёров или форс-мажорными обстоятельствами
— Точное соответствие букета изображению на сайте
— Убытки, возникшие в результате использования услуг третьих лиц

Максимальная ответственность сервиса ограничена суммой оплаченного заказа.`
      },
      {
        title: "9. Интеллектуальная собственность",
        text: `Все материалы сайта (тексты, изображения, дизайн, логотип) являются интеллектуальной собственностью YUCCA Flowers и защищены законодательством об авторском праве. Копирование и использование материалов без письменного согласия запрещено.`
      },
      {
        title: "10. Изменения в соглашении",
        text: `Мы оставляем за собой право вносить изменения в настоящее Соглашение в любое время. Актуальная версия всегда доступна на данной странице. Продолжая использовать сайт после внесения изменений, вы принимаете обновлённые условия.`
      },
      {
        title: "11. Контакты",
        text: `По всем вопросам, связанным с данным Соглашением, вы можете связаться с нами:
— WhatsApp: +90 531 622 43 78
— Telegram: @Yucca_flower
— Сайт: yuccaflower.com`
      }
    ]
  },
  en: {
    title: "Terms of Service",
    updated: "Last updated: March 28, 2025",
    sections: [
      {
        title: "1. General Provisions",
        text: `These Terms of Service (hereinafter referred to as the "Agreement") govern the relationship between YUCCA Flowers (hereinafter referred to as the "Service", "we") and the user of the website yuccaflower.com (hereinafter referred to as the "User", "you").

By using the website, you confirm that you have read, understood, and agree to the terms of this Agreement. If you do not agree with any of the terms, please stop using the website.`
      },
      {
        title: "2. About the Service",
        text: `YUCCA Flowers is a flower delivery aggregator service. We are NOT a florist shop, we do NOT have our own retail locations, and we do NOT deliver bouquets ourselves.

All orders are fulfilled by third parties — independent florists and delivery services in the respective cities. YUCCA Flowers acts exclusively as a platform connecting customers with service providers.

We make every effort to select reliable partners, however, we do not bear direct responsibility for the quality of goods and services provided by third parties.`
      },
      {
        title: "3. Placing an Order",
        text: `Orders are placed through WhatsApp and Telegram messengers. When placing an order, you provide:
— Selected bouquet and its price
— Delivery address and time
— Recipient's contact information

After order confirmation, the information is forwarded to the partner executor in the selected city.`
      },
      {
        title: "4. Prices and Payment",
        text: `Prices on the website are listed in the base currency of the region (USD for Turkey, EUR for Spain). Conversion to other currencies is carried out at the current exchange rate, including a conversion fee.

The final order cost may differ from the price listed on the website depending on the availability of specific flowers and delivery conditions. The final price is agreed upon when placing the order.

Payment methods are discussed individually when placing an order through the messenger.`
      },
      {
        title: "5. Delivery",
        text: `Delivery is carried out by third parties — service partners in the respective cities. Delivery terms and conditions depend on the specific city, order time, and courier availability.

We strive to ensure same-day delivery, however, we cannot guarantee this in all cases. In case of delays or delivery issues, we assist in resolving the matter with the partner.`
      },
      {
        title: "6. Photo Before Sending",
        text: `We provide a bouquet photography service before dispatch. The photo is sent to the customer via messenger for confirmation. The appearance of the bouquet may slightly differ from the website photo depending on seasonal flower availability.`
      },
      {
        title: "7. Returns and Cancellation",
        text: `Return and cancellation policy:
— The order can be cancelled before its execution begins (bouquet assembly) without any penalties.
— After the bouquet assembly has started, refunds are discussed individually.
— In case of inadequate bouquet quality, we assist in resolving the issue with the partner executor.`
      },
      {
        title: "8. Limitation of Liability",
        text: `YUCCA Flowers, as an aggregator, is not responsible for:
— The quality and freshness of flowers provided by third parties
— Delivery delays caused by partners' actions or force majeure circumstances
— Exact correspondence of the bouquet to the website image
— Losses arising from the use of third-party services

The maximum liability of the service is limited to the amount of the paid order.`
      },
      {
        title: "9. Intellectual Property",
        text: `All website materials (texts, images, design, logo) are the intellectual property of YUCCA Flowers and are protected by copyright law. Copying and use of materials without written consent is prohibited.`
      },
      {
        title: "10. Changes to the Agreement",
        text: `We reserve the right to make changes to this Agreement at any time. The current version is always available on this page. By continuing to use the website after changes are made, you accept the updated terms.`
      },
      {
        title: "11. Contact Information",
        text: `For all questions related to this Agreement, you can contact us:
— WhatsApp: +90 531 622 43 78
— Telegram: @Yucca_flower
— Website: yuccaflower.com`
      }
    ]
  }
};

export default function TermsPage() {
  const [lang, setLang] = useState(() => getLangFromWindow(["ru", "en"]));
  const t = content[lang];

  useEffect(() => {
    document.title = lang === "ru" 
      ? "Пользовательское соглашение — YUCCA Flowers" 
      : "Terms of Service — YUCCA Flowers";
  }, [lang]);

  return (
    <div className="min-h-screen bg-zinc-950 text-gray-200" data-testid="terms-page">
      <div className="max-w-3xl mx-auto px-4 py-12 sm:py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-pink-400 hover:text-pink-300 mb-8 text-sm transition-colors" data-testid="terms-back-link">
          <ArrowLeft className="w-4 h-4" />
          {lang === "ru" ? "На главную" : "Back to Home"}
        </Link>

        <div className="flex items-center justify-between mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-white" data-testid="terms-title">{t.title}</h1>
          <button
            onClick={() => { const newLang = lang === "ru" ? "en" : "ru"; setLang(newLang); localStorage.setItem("yucca_lang", newLang); }}
            className="text-sm px-3 py-1.5 rounded-full border border-white/20 text-gray-400 hover:text-white hover:border-white/40 transition-colors"
            data-testid="terms-lang-toggle"
          >
            {lang === "ru" ? "EN" : "RU"}
          </button>
        </div>

        <p className="text-gray-500 text-sm mb-10">{t.updated}</p>

        <div className="space-y-8">
          {t.sections.map((section, i) => (
            <section key={i}>
              <h2 className="text-lg font-semibold text-white mb-3">{section.title}</h2>
              <p className="text-gray-300 leading-relaxed whitespace-pre-line text-sm">{section.text}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
